import { defineMessages } from 'react-intl';

export default defineMessages({
  optinTitle: {
    id: 'email.subscribe.optin_required.title',
    defaultMessage: 'Almost there!',
  },
  optinMessage: {
    id: 'email.subscribe.optin_required.message',
    defaultMessage: 'Check your inbox to confirm your newsletter subscription',
  },
  optinLink: {
    id: 'email.subscribe.optin_required.link',
    defaultMessage: 'Open your inbox',
  },
});
